import { render } from "./FixtureScorboard.vue?vue&type=template&id=6bc4c97e&scoped=true"
import script from "./FixtureScorboard.vue?vue&type=script&lang=js"
export * from "./FixtureScorboard.vue?vue&type=script&lang=js"

import "./FixtureScorboard.vue?vue&type=style&index=0&id=6bc4c97e&scoped=true&lang=css"

import exportComponent from "C:\\Users\\HS\\Desktop\\fikstur\\my_fiksture\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6bc4c97e"]])

export default __exports__